/**
 * Node Modules
 */
import React from 'react'
import { Link } from 'gatsby'

/**
 * Application Modules
 */
import './style.css'
import '../../../components/styles/buttons.css'
import Section from '../../../components/section'

/**
 * Component
 */
export default function LifeAtKinzoo({ hed, dek }) {
  return (
    <Section className="life-at-kinzoo" id="life-at-kinzoo">
      <div className="life-at-kinzoo__grid grid">
        <h2 className="life-at-kinzoo__hed column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
          {hed}
        </h2>
        <p className="life-at-kinzoo__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
          {dek}
        </p>
        <div className="flex flex-center column-start-1 column-end-6 column-end-12--t">
          <Link to="/our-values" className="reset button button--f4 button--yellow">
            Our Values
          </Link>
        </div>
      </div>
    </Section>
  )
}
